import React from 'react';
import { Box, Typography } from '@mui/material';
import LiveKitPresence from './LiveKitPresence';
import TempMeetingRoom from './TempMeetingRoom';
import MyMeetingHistory from './MyMeetingHistory';

// Combines the three virtual-presence sections that used to live on the Attendance page
// (Virtual Office, starting/joining a temporary meeting, and the join history) into one
// "Generate Meeting" page under the Meetings nav group — same three components, unchanged,
// just moved together onto their own page.
const GenerateMeetingPage: React.FC = () => (
  <Box sx={{ p: 3 }}>
    <Typography variant="h6" gutterBottom fontWeight="bold">Generate Meeting</Typography>
    <LiveKitPresence />
    <TempMeetingRoom />
    <MyMeetingHistory />
  </Box>
);

export default GenerateMeetingPage;
